<template>   
<!--<div id="app">
    <h1 v-fly-in="{ distance: 100, duration: 1, delay: 500 }">Fly-In Test</h1>
  </div>
<div id="app"><h1 v-test>Test Directive</h1></div>-->
    <router-view></router-view>  <!-- 这里将渲染路由对应的页面组件 <router-link to="/">首页</router-link>-->
</template>

<script>

export default {
  
}
</script>

<style>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box; /* 确保包括padding和border在内的总宽度和高度 */
  overflow-x:hidden;
  scroll-behavior: smooth;
}
html {
  font-size: 16px; /* 默认 16px */
}

/* 使用媒体查询来调整根字号 */
@media (max-width: 768px) {
  html {
    font-size: 14px; /* Pad 和手机端字体稍微小一些 */
  }
}
#app {
  font-family: Futura, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 0px;
}



</style>